import { useState, useEffect, useCallback, useRef } from "react";
import { getSectionTypesURL } from "../../utils/ConstantsURL";

export function useSectionTitle(token, idDocument) {
  const [sectionTitle, setSectionTitle] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshIndex, setRefreshIndex] = useState(0);
  const resolveRefreshRef = useRef(null);

  const refresh = useCallback(() => {
    return new Promise((resolve) => {
      resolveRefreshRef.current = resolve;
      setRefreshIndex((prev) => prev + 1);
    });
  }, []);

  useEffect(() => {
    if (!token || !idDocument) return;

    const fetchSectionTitle = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(getSectionTypesURL(idDocument), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Error desconocido");
        setSectionTitle(data);
      } catch (err) {
        console.error("useSectionTitle:", err);
        setError(err);
      } finally {
        setLoading(false);
        if (resolveRefreshRef.current) {
          resolveRefreshRef.current();
          resolveRefreshRef.current = null;
        }
      }
    };

    fetchSectionTitle();
  }, [token, idDocument, refreshIndex]);

  return { sectionTitle, loading, error, refresh };
}
